import type { AddToListsTarget } from "@/lib/add-to-lists-target";

export type CatalogTargetWishlistState = "none" | "work" | "exact-release" | "related-release";

export function catalogTargetWishlistState({
  fallbackMembership,
  getListIdsForRelease,
  hydrated,
  listId,
  target,
}: {
  fallbackMembership: boolean;
  getListIdsForRelease: (releaseId: string) => Set<string>;
  hydrated: boolean;
  listId: string | undefined;
  target: AddToListsTarget;
}): CatalogTargetWishlistState {
  if (!hydrated || !listId) return "none";
  if (target.entityType === "work") return fallbackMembership ? "work" : "none";
  if (getListIdsForRelease(target.releaseId).has(listId)) return "exact-release";
  return fallbackMembership ? "related-release" : "none";
}
